import { Avatar, Button, Divider, Stack, Typography } from '@mui/material';
import { IEntitlement } from 'API/compassRights';
import { ButtonsBackground } from 'Components/ButtonsBackground';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import {
  EmploymentIcon,
  FromHeart,
  LeftArrow,
  SocialHelp,
  Statoscope,
} from 'Images';
import { useNavigate } from 'react-router-dom';

export const Card = ({
  entitlementTypeId,
  shortExplanation,
  name,
  fullExplanation,
}: IEntitlement) => {
  const navigate = useNavigate();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).userRights;
  const isDesktop = useIsDesktop();

  const mobileIcons: { [index: number]: { img: string } } = {
    1: { img: FromHeart },
    2: { img: Statoscope },
    3: { img: SocialHelp },
    4: { img: EmploymentIcon },
  };

  return (
    <Stack
      sx={{
        boxShadow: '-2px -2px 10px 0px rgba(8, 30, 84, 0.04)',
        backgroundColor: 'primary.shade_50',
        border: '1px solid',
        borderColor: 'primary.shade_200',
        borderRadius: '16px',
        justifyContent: 'space-between',
        pt: isDesktop ? '20px' : 0,
        position: 'relative',
        maxWidth: isDesktop ? '366px' : undefined,
      }}
    >
      <Stack flexDirection={'row'}>
        {!isDesktop && (
          <Stack sx={{ width: '40px', p: '18px 16px' }}>
            <Avatar
              src={mobileIcons[2].img}
              alt=''
              sx={{ width: '40px', height: '40px' }}
            />
          </Stack>
        )}
        <Stack sx={{ overflow: 'hidden' }}>
          <Typography
            variant={isDesktop ? 'body1' : 'body2'}
            sx={{
              p: isDesktop ? '16px 24px' : '16px 24px 8px 24px',
              minHeight: isDesktop ? '80px' : undefined,
            }}
          >
            {name}
          </Typography>
          {isDesktop && (
            <Divider
              aria-hidden='true'
              sx={{
                borderColor: 'primary.shade_100',
                m: '0 24px',
              }}
            />
          )}
          <Typography
            component={'p'}
            variant={isDesktop ? 'body6' : 'body3'}
            sx={{
              p: isDesktop ? '24px 24px 32px' : '0px 24px 24px',
              display: '-webkit-box',
              WebkitLineClamp: 4,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxHeight: isDesktop ? '115px' : '100px',
              mb: '20px',
            }}
          >
            {fullExplanation}
          </Typography>
        </Stack>
      </Stack>

      <Stack
        sx={{
          backgroundColor: 'primary.shade_100',
          borderRadius: '0 0 16px 16px',
          p: isDesktop ? '10px 24px' : '5px 24px',
          alignItems: 'end',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <ButtonsBackground />
        <Button
          onClick={() => navigate(`/compass-rights/${entitlementTypeId}`)}
          sx={{ display: 'flex', p: '6px 0' }}
        >
          <Typography variant='body5'>
            {isDesktop ? dictionary.moreInfo : dictionary.moreInfoMobile}
          </Typography>
          <Avatar
            src={LeftArrow}
            alt=''
            sx={{ width: '20px', height: '20px' }}
          />
        </Button>
      </Stack>
    </Stack>
  );
};
